import React from "react";
import { Container } from "react-bootstrap";
import Particle from "./Particle";

function PrivacyPolicy() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div
          className="legal-content"
          style={{
            padding: "50px 20px",
            textAlign: "left",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "10px",
            marginTop: "120px",
            color: "#333",
          }}
        >
          <h1 style={{ textAlign: "center", marginBottom: "30px", color: "#2c3e50" }}>
            Privacy Policy for Hangman Go
          </h1>

          <p><strong>Effective Date: October 2025</strong></p>

          <h3>1) Scope</h3>
          <p>
            This Privacy Policy explains how Hangman Go (“App”, “we”, “us”) processes information when you use the App.
            The App is designed for general audiences and can be used without creating an account.
          </p>

          <h3>2) Information We Process</h3>
          <h4>A. Information You Provide</h4>
          <ul>
            <li>No account or personal registration is required to play.</li>
            <li>In-App purchase actions are handled by Apple App Store or Google Play; we do not receive your full payment details.</li>
          </ul>

          <h4>B. Automatically Processed Information</h4>
          <ul>
            <li><strong>Local game data</strong>: progress, settings, language, inventory (stored on your device).</li>
            <li><strong>Purchase status & entitlements</strong>: limited purchase receipts / entitlement status (via store and/or RevenueCat) to unlock paid content.</li>
            <li><strong>Device & usage data</strong>: basic diagnostics, app version, performance data (used to improve stability and fix bugs).</li>
            <li><strong>Advertising identifiers</strong>: Apple IDFA / Google AAID and related signals processed by ad networks (e.g., Google AdMob) for ad delivery and, where permitted, personalization/frequency capping/fraud prevention.</li>
          </ul>

          <h3>3) Purposes of Processing</h3>
          <ul>
            <li>Provide core gameplay, save local progress, and restore purchases/entitlements.</li>
            <li>Process payments and subscriptions through platform stores.</li>
            <li>Show ads (including rewarded ads where available) and measure their performance.</li>
            <li>Maintain security, prevent fraud/abuse, and improve App performance.</li>
          </ul>

          <h3>4) Data Storage & Retention</h3>
          <ul>
            <li>Game progress is stored locally on your device. Deleting the App removes local data.</li>
            <li>Store/RevenueCat purchase records and limited analytics/diagnostic data may be retained as required for legitimate purposes (e.g., billing, compliance, debugging) and then deleted or anonymized.</li>
          </ul>

          <h3>5) Third-Party Services</h3>
          <p>We integrate third parties to operate the App. Their processing is governed by their own terms/policies:</p>
          <ul>
            <li><strong>Apple App Store / Google Play Billing</strong>: purchases, subscriptions, refunds, price changes.</li>
            <li><strong>RevenueCat</strong>: subscription & entitlement management (verifies active purchases to unlock content).</li>
            <li><strong>Google AdMob</strong>: ad serving, measurement, fraud prevention; may use device identifiers and related signals.</li>
            {/* <li><strong>Game Center / Play Games</strong> (if enabled): achievements/leaderboards.</li> */}
          </ul>

          <h3>6) Children’s Privacy</h3>
          <ul>
            <li>The App is family-friendly; we do not knowingly collect personal data from children.</li>
            <li>Where required by law or platform policy, personalized ads are limited or disabled for child users.</li>
            <li>Parents/guardians should supervise use and can manage device privacy/ad settings.</li>
          </ul>

          <h3>7) Your Choices</h3>
          <ul>
            <li><strong>Delete local data</strong>: uninstall the App.</li>
            <li><strong>Ads preferences</strong>: reset/limit Ad IDFA/AAID, “Limit Ad Tracking” / “Opt-out of Ads Personalization” in device settings.</li>
            <li><strong>Consent (EEA/UK where applicable)</strong>: you may be shown a consent prompt for ads; you can revisit choices in the App (if provided) or device settings.</li>
          </ul>

          <h3>8) Legal Bases & Your Rights</h3>
          <p>
            Where the GDPR applies, we rely on: performance of a contract (providing the App), legitimate interests
            (fraud prevention, analytics, service improvement), and consent (personalized ads where required).
            Under KVKK and/or GDPR (if applicable), you may have rights to access, correct, delete, restrict, object to processing,
            and data portability. You can exercise rights via the contact below; for purchases/refunds manage via the store.
          </p>

          <h3>9) Data Sharing</h3>
          <ul>
            <li>We do not sell your personal data.</li>
            <li>We share data only with service providers listed above, when required by law, or to protect our rights/users.</li>
          </ul>

          <h3>10) International Transfers</h3>
          <p>
            Third-party processors (e.g., AdMob, RevenueCat, Apple/Google) may process data on servers outside your country.
            Where required, safeguards (such as standard contractual clauses) may apply under their policies.
          </p>

          <h3>11) Security</h3>
          <p>
            We use reasonable technical and organizational measures appropriate to the nature of the data and our App.
            No method of transmission or storage is 100% secure.
          </p>

          <h3>12) Updates to This Policy</h3>
          <ul>
            <li>We may update this Policy from time to time to reflect changes in features or law.</li>
            <li>Material changes will be communicated in-App and/or via the store listing. Continued use means you accept the updated Policy.</li>
          </ul>

          <h3>13) Contact</h3>
          <p>For privacy questions or to exercise your rights, contact us:</p>
          <ul>
            <li>Email: <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a></li>
            <li>Website: <a href="https://www.suleymanozdemirci.com/project" target="_blank" rel="noreferrer">https://www.suleymanozdemirci.com/project</a></li>
            <li>We aim to respond within 7 business days.</li>
          </ul>

          <h3>14) Compliance Statement</h3>
          <ul>
            <li>Designed to align with Türkiye’s KVKK.</li>
            <li>Intended to meet Google Play / Apple App Store disclosure expectations.</li>
            <li>Where applicable, aligned with GDPR/EEA children’s privacy and advertising requirements.</li>
          </ul>

          <hr style={{ margin: "30px 0" }} />
          <p><strong>Last Updated: October 2025</strong></p>
        </div>
      </Container>
    </Container>
  );
}

export default PrivacyPolicy;
